import React, { Suspense } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import ScrollMemory from 'react-router-scroll-memory';
import I18nProvider from './locale/I18nProvider';
import LoadingOverlay from './modules/components/LoadingOverlay/LoadingOverlay';
import AppRoute from './router/AppRoute';
import routes from './router/routes';
import { AIConfigProvider } from './state/AIConfigContext';
import { LemonadeConfigProvider } from './state/LemonadeConfigContext';
import { MintConfigProvider } from './state/MintConfigContext';

function App() {
  return (
    <I18nProvider>
      <Suspense fallback={<LoadingOverlay theme='dark' />}>
        <Router>
          <ScrollMemory />
          <div className='App'>
            <LemonadeConfigProvider>
              <MintConfigProvider>
                <AIConfigProvider>
                  <Switch>
                    {routes.map((route) => (
                      <AppRoute
                        key={route.path}
                        path={route.path}
                        component={route.component}
                        isPrivate={route.isPrivate}
                        provider={route.provider}
                        {...route.props}
                      />
                    ))}
                  </Switch>
                </AIConfigProvider>
              </MintConfigProvider>
            </LemonadeConfigProvider>
          </div>
        </Router>
      </Suspense>
    </I18nProvider>
  );
}

export default App;
